import { render, staticRenderFns } from "./GrupoProcesos.vue?vue&type=template&id=87a8eeb8&"
import script from "./GrupoProcesos.vue?vue&type=script&lang=js&"
export * from "./GrupoProcesos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports